module.exports = __webpack_public_path__ + "img/addPlusIcon.e465a8a9.svg";